<template>
  <div class="container" id="app">
    <router-view name="breadCrumb" />
    <div class="columnLayout">
      <router-view name="child" />
      <div class="sidebar">
        <ul class="snavButtons">
          <li class="snavButtons_item snavButtons_item-home">
            <router-link :to="{path: '/home/', params: { slug: 'home', id: 15 }}">家庭用商品</router-link>
          </li>
          <li class="snavButtons_item snavButtons_item-business">
            <router-link :to="{path: '/business/', params: { slug: 'business', id: 15 }}">業務用商品</router-link>
          </li>
          <li class="snavButtons_item snavButtons_item-gift">
            <router-link :to="{path: '/gift/', params: { slug: 'gift', id: 17 }}">ギフト用商品</router-link>
          </li>
        </ul>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue